// WordPressのBlogusのCSS、JSファイルを使用してます。（リンクは下記）
// @see https://wordpress.org/themes/blogus/
// やり方：WordPressのローカル環境にBlogusテンプレートをインストールして適用し、ブラウザからホーム画面を開き、headとbodyをコピーしてlocalhost:8000 で取得しているcssとjsを一つづつwebpackerに取り込んで検証していく
// ページ毎のJS/CSSファイル読み込みについては下記の通り。
// @see: https://qiita.com/minsu/items/e326578e174891dbeac0

// JSファイル
import "src/js/blog/public/theme_1/jquery.js";
import "src/js/blog/public/theme_1/jquery-migrate.js";
import "src/js/blog/public/theme_1/navigation.js";
import "src/js/blog/public/theme_1/bootstrap.js";
import "src/js/blog/public/theme_1/swiper-bundle.js";
import "src/js/blog/public/theme_1/main.js";
import "src/js/blog/public/theme_1/sticksy.min.js";
import "src/js/blog/public/theme_1/jquery.smartmenus.js";
// TODO: webpackerでエラーが出るため下記ファイルは修正必要。だが、見た目上もあまり影響が無いので保留。
// import "src/js/blog/public/theme_1/jquery.smartmenus.bootstrap.js";
import "src/js/blog/public/theme_1/emoji-release.js";

// 下記JSファイルは使うかわからない
// import "src/js/blog/public/theme_1/admin/customizer-admin.js";
// import "src/js/blog/public/theme_1/skip-link-focus-fix.js";
// import "src/js/blog/public/theme_1/custom.js";
// import "src/js/blog/public/theme_1/customizer.js";
// import "src/js/blog/public/theme_1/dark.js";
// import "src/js/blog/public/theme_1/widget-image.js";

// CSSファイル
import "src/css/blog/public/theme_1/bootstrap.css";
import "src/css/blog/public/theme_1/style.css";
import "src/css/blog/public/theme_1/colors/default.css";
import "src/css/blog/public/theme_1/all.css";
import "src/css/blog/public/theme_1/colors/dark.css";
import "src/css/blog/public/theme_1/swiper-bundle.css";
import "src/css/blog/public/theme_1/jquery.smartmenus.bootstrap.css";
import "src/css/blog/public/theme_1/animate.css";
import "src/css/blog/public/theme_1/block-library-style.css";
import "src/css/blog/public/theme_1/classic-themes.css";


// 下記CSSファイルは使うかわからない
// import "src/css/blog/public/theme_1/admin-style.css";
// import "src/css/blog/public/theme_1/editor-style.css";
// import "src/css/blog/public/theme_1/customizer-controls.css";
// import "src/css/blog/public/theme_1/style-rtl.css";
// import "src/css/blog/public/theme_1/customize-style.css";
